/*
 *
 * InvoicePayment
 *
 */

import React from "react";
import { Container, Col, Navbar } from "react-bootstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import { personalUrl } from "utils/env";
import LogoImage from "../../resources/images/Criteria-Logo.png";
import LogoImageSmall from "../../resources/images/CriteriaLogo_Small.png";
import Header from "./Header";
import OrderForm from "../../components/OrderForm";

// Style Variables
const navbar = {
  backgroundColor: "#001f4e",
  borderRadius: "0",
  borderColor: "#001f4e",
  padding: "9px",
  fontFamily: "Lato",
};

// eslint-disable-next-line react/prefer-stateless-function
export class InvoicePayment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageToShow: "orderPage",
      orderInProcess: false,
      creditCardInvalid: false,
      showPage: false,
    };
  }

  /* ---------- React LifeCylce Methods ---------- */

  componentDidMount() {
    const encryptedInvoiceNumber = location.pathname.split("/")[2];
    this.fetchPricingData(encryptedInvoiceNumber);
  }

  /* ----------- Event Handlers ------------ */

  updatePageToShow = (location) => {
    this.setState({
      pageToShow: location,
    });
  };

  /* --------- Fetch functions ---------- */

  fetchPricingData = async (encryptedInvoiceNumber) => {
    let fetchUrl = `${personalUrl}payEncryptedInvoice/${encryptedInvoiceNumber}`;
    if (this.props.version === "pay-invoice") {
      fetchUrl = `${fetchUrl}/1`;
    }
    try {
      const response = await fetch(fetchUrl);
      const data = await response.json();
      if (response.status === 400) {
        this.setState({ errorMessage: data });
      }

      this.setState({
        billingInfoFromInvoice: {
          companyName: data.data.billing.companyName,
          firstName: data.data.billing.firstName,
          lastName: data.data.billing.lastName,
          emailAddress: data.data.billing.emailAddress,
          jobTitle: data.data.billing.jobTitle,
          addressStreet: data.data.billing.addressStreet,
          addressStreet2: data.data.billing.addressStreet2,
          addressCity: data.data.billing.addressCity,
          addressState: data.data.billing.addressState,
          addressZip: data.data.billing.addressZip,
          addressCountry: data.data.billing.addressCountry,
          telephoneNumber: data.data.billing.telephoneNumber,
          faxNumber: data.data.billing.faxNumber,
          contractPrice: data.data.pricing.price,
          contractMonths: data.data.pricing.months,
          companyAccountId: data.data.billing.companyAccountId,
          token: data.data.jwt,
          invoiceNumber: data.data.data.invoiceNumber,
          disableTax: data.data.company.disableTax,
          taxAmount: data.data.pricing.tax,
          userAccountId: data.data.billing.userAccountId,
          allowPaymentPlan: data.data.company.allowPaymentPlan,
          subsidiary: data.data.pricing.subsidiary,
        },
        showPage: true,
      });
    } catch (error) {
      if (!this.state.errorMessage) {
        this.setState({
          errorMessage: "This is an invalid invoice number.",
        });
      }
    }
  };

  payInvoice = async (formData) => {
    this.setState({ orderInProcess: true });
    try {
      const response = await fetch(`${personalUrl}subscribe`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: this.state.billingInfoFromInvoice.token,
        },
        body: JSON.stringify(formData),
      });
      const { status } = response;
      if (status === 200) {
        this.setState({
          showSuccessComponent: true,
          orderInProcess: false,
        });
      } else {
        let errorMessage;
        await response.json().then((res) => {
          errorMessage = res;
        });
        this.setState({ errorMessage, orderInProcess: false });
      }
    } catch (error) {
      this.setState({
        errorMessage: "There was a problem with accepting your payment",
        creditCardInvalid: true,
        orderInProcess: false,
      });
    }
  };

  render() {
    const LogoImgSmall = styled.img`
      margin: 5px;
      @media (min-width: 1051px) {
        display: none;
      }
    `;
    const LogoImgBig = styled.img`
      @media (max-width: 1050px) {
        display: none;
      }
    `;

    const pricingInfo = {
      price: this.state.billingInfoFromInvoice
        ? this.state.billingInfoFromInvoice.contractPrice
        : null,
      months: this.state.billingInfoFromInvoice
        ? this.state.billingInfoFromInvoice.contractMonths
        : null,
      companyPricingId: this.state.billingInfoFromInvoice
        ? this.state.billingInfoFromInvoice.companyAccountId
        : null,
    };

    return (
      <div>
        {this.state.showSuccessComponent ? (
          <div>
            <Navbar variant="dark" style={navbar} defaultExpanded>
              <a href="/">
                <LogoImgBig src={LogoImage} alt="Criteria Logo" />
                <LogoImgSmall
                  src={LogoImageSmall}
                  alt="Criteria Logo"
                  width="30"
                  height="30"
                  className="text-center"
                />
              </a>
            </Navbar>
            <Header />
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="text-center"
              style={{ marginTop: "50px" }}
            >
              <h2>Thank you for your order.</h2>
              <a
                href="https://hireselect.criteriacorp.com/"
                style={{ fontSize: "22px" }}
              >
                Log in to your account.
              </a>
            </Col>
          </div>
        ) : (
          <div>
            <Navbar variant="dark" style={navbar} defaultExpanded>
              <a href="/">
                <LogoImgBig src={LogoImage} alt="Criteria Logo" />
                <LogoImgSmall
                  src={LogoImageSmall}
                  alt="Criteria Logo"
                  width="30"
                  height="30"
                  className="text-center"
                />
              </a>
            </Navbar>
            <Header />
            <div>
              <Container>
                {(this.state.pageToShow === "orderPage" ||
                  this.state.pageToShow === "/paymentPage") &&
                this.state.showPage ? (
                  <Container>
                    <OrderForm
                      pricing={pricingInfo}
                      billingInfoFromInvoicePage={
                        this.state.billingInfoFromInvoice
                      }
                      callLocation={this.state.pageToShow}
                      updatePageToShow={this.updatePageToShow}
                      onHandlePurchaseOrUpgrade={this.payInvoice}
                      creditCardInvalid={this.state.creditCardInvalid}
                      errorMessage={this.state.errorMessage}
                      orderInProcess={this.state.orderInProcess}
                      invoiceNumber={
                        this.state.billingInfoFromInvoice.invoiceNumber
                      }
                    ></OrderForm>
                  </Container>
                ) : null}
              </Container>
            </div>
          </div>
        )}
      </div>
    );
  }
}

InvoicePayment.propTypes = {
  version: PropTypes.string,
};

export default InvoicePayment;
